import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { ERestoreStatus } from '../../../../types/authentication';
import { isEmail } from '../../../../utils/validation';
import { InputField } from '../../../../components/InputField';
import { ContentLayout } from '../../../../components/ContentLayout';
import { EActiveView } from '../../../../types/view';
import { EKeyCode } from '../../../../types/keyCodes';
import { FormFieldGroupLayout } from '../../../../components/FieldGroupLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FormContainer(_ref) {
  var initialEmail = _ref.initialEmail,
    error = _ref.error,
    status = _ref.status,
    changeView = _ref.changeView,
    restore = _ref.restore;
  var emailRef = React.useRef(null);
  var _React$useState = React.useState(initialEmail),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    email = _React$useState2[0],
    setEmail = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    touched = _React$useState4[0],
    setTouched = _React$useState4[1];
  var _React$useState5 = React.useState(!!error),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    changed = _React$useState6[0],
    setChanged = _React$useState6[1];
  var _React$useState7 = React.useState(isEmail(email)),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isEmailInValid = _React$useState8[0],
    setEmailInvalid = _React$useState8[1];
  var handleChangeEmail = React.useCallback(function (e) {
    var value = e.currentTarget.value;
    setEmail(value);
    setChanged(true);
    setEmailInvalid(!!value && !isEmail(value));
  }, []);
  var handleSubmit = React.useCallback(function () {
    setTouched(true);
    if (!email || !isEmail(email) || status === ERestoreStatus.Loading) {
      if (emailRef.current) {
        emailRef.current.focus();
      }
      return;
    }
    restore(email);
  }, [email, status, restore]);
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleSubmitOnEnter = React.useCallback(function (e) {
    if (e.keyCode === EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  var switchToRegister = React.useCallback(function () {
    changeView(EActiveView.AuthenticationRegistration);
  }, [changeView]);
  return /*#__PURE__*/_jsx(ContentLayout, {
    children: /*#__PURE__*/_jsx("form", {
      onSubmit: handlePreventSubmit,
      children: /*#__PURE__*/_jsx(FormFieldGroupLayout, {
        content: /*#__PURE__*/_jsx(InputField, {
          "data-name": "EmailInput",
          autoFocus: true,
          name: "email",
          ref: emailRef,
          onChange: handleChangeEmail,
          onKeyDown: handleSubmitOnEnter,
          placeholder: "Email",
          invalid: touched && (status === ERestoreStatus.Failed && !changed || isEmailInValid),
          errorMessage: touched && status === ERestoreStatus.Failed && !changed ? error : undefined,
          value: email,
          disabled: status === ERestoreStatus.Loading
        }),
        buttons: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Button, {
            "data-name": "ContinueAuthBtn",
            theme: "fill_primary",
            fullWidth: true,
            disabled: status === ERestoreStatus.Loading,
            loading: status === ERestoreStatus.Loading,
            onClick: handleSubmit,
            children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"
          }), /*#__PURE__*/_jsx(Button, {
            "data-name": "CreateAccountBtn",
            theme: "fill_secondary",
            fullWidth: true,
            onClick: switchToRegister,
            children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442"
          })]
        })
      })
    })
  });
}